export default __webpack_public_path__ + "static/media/6.26dc5423.jpg";